import {Nut_Lp_Actions_InsertDynamicScripts as InsertDynamicScripts} from 'nutshell-core/settings-constants';

import {useGetSetting} from '../../../core/use-get-setting';
import {useUpdateSetting} from '../../../core/use-update-setting';

export const useGetIsAnalyticsDisabled = (): {
    isAnalyticsDisabled: boolean;
    onUpdateIsAnalyticsDisabled: (arg1: boolean) => Promise<any>;
    isLoading: boolean;
} => {
    const {setting, isLoading} = useGetSetting({
        settingName: InsertDynamicScripts.DISABLE_MCFX_TRACKING_SETTING_NAME,
    });
    const updateSetting = useUpdateSetting();

    const onUpdateIsAnalyticsDisabled = (newValue: boolean) =>
        updateSetting({
            settingName: InsertDynamicScripts.DISABLE_MCFX_TRACKING_SETTING_NAME,
            isGlobal: true,
            value: newValue ? 1 : 0,
        });

    return {
        isAnalyticsDisabled: setting ? Boolean(Number(setting.value)) : false,
        isLoading,
        onUpdateIsAnalyticsDisabled,
    };
};
